<script>
    import {navigate} from 'svelte-routing';
    import {api} from '../stores.js';

    let email = '';
    
    const handlerClick = async () => {
        let popup = new bootstrap.Modal(document.getElementById('reset-password'));
        
        if (email) {
            let result = await api('appUserResetPassword', {login: email});
            
            if (result.data && result.data.pasport) {
                let fd = new FormData;
                fd.append('email', email);
                fd.append('password', result.data.pasport);
    
                await fetch(location.origin + '/form/vosstanovlenie-parolya', {
                    method: 'POST',
                    body: fd
                });
            }
            
            popup.show();
            setTimeout(() => {popup.hide(); navigate('/')}, 1000 * 5);
        }
    }
</script>

<div id="appCapsule">
    <div class="login-form mt-1">
        <div class="section mt-1">
            <h1>Восстановление пароля</h1>
            <h4>Введите ваш E-Mail для восстановления пароля</h4>
        </div>
        <div class="section mt-1 mb-5">
            <form>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="email" class="form-control" name="email" bind:value={email} placeholder="E-Mail">
                    </div>
                </div>
    
                <div class="form-button-group">
                    <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerClick}>
                        Сбросить
                    </button>
                </div>
            </form>
        </div>
    </div>
    
    <div class="modal fade dialogbox" id="reset-password" data-bs-backdrop="static" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-icon text-success">
                    <ion-icon name="checkmark-circle" role="img" class="md hydrated" aria-label="checkmark circle"></ion-icon>
                </div>
                <div class="modal-header">
                    <h5 class="modal-title">Успешно!</h5>
                </div>
                <div class="modal-body">
                    На указанную почту было отправлено письмо с паролем.
                </div>
            </div>
        </div>
    </div>
</div>
